import Network from '@/services/network'
import {useStatistics} from '@/services/modules/dashboard/statistics.js'
import figureFormatter from '@/services/utils/figureFormatter.js'
import { ref } from 'vue'

export default function handleCompany() {
    const network = new Network;
    const loading = ref(false)
    const {makeStatistics} = useStatistics()
    const {commaFormat} = figureFormatter()

    const fetchSidebar = (query) => {
      return network.api('get', '/get/sidebar'+query);
    }

    const fetchCompanyInfo = async (id) => {
      const companyData = localStorage.getItem('companyData');
      if (companyData) {
        try {
          return JSON.parse(companyData)
        } catch (err){}
      }
      const fetchedCompanyData = await network.api('get', '/company/' + id);
      localStorage.setItem('companyData', JSON.stringify(fetchedCompanyData))
      return fetchedCompanyData;
    }

    const fetchCompanyDetails = (id) => {
      return network.api('get', '/company-info/'+id);
    }

    const clearCompanyData = () => {
      localStorage.removeItem('companyData');
    }

    const fetchCompanyModules = (id) => {
      return network.api('get', '/get/modules/'+id);
    }

    const createCompany = (data) => {
      return network.api('post', '/company', data);
    }
     // fetchUpdateCompany
    const fetchUpdateCompany = (id,data) => {
      return network.api('post', '/company/'+id,data);
    }

    const fetchCompanyList = () => {
      return network.api('get', '/company');
    }

    const fetchMenu = (query) => {
      return network.api('get', '/menu/comparing'+query);
    }

    const updateMenu = (data) => {
      return network.api('post', '/menu/update', data);
    }
    const compareWithUpdateMenu = (query) => {
        return network.api('get', '/menu/compare-with-update'+query);
    }
    const getDashboard = (companyId) => {
      return network.api('get', '/get/dashboard?module_id=1&company_id='+companyId);
    }

    const fetchAllModules = () => {
        return network.api('get', '/get/modules/all');
    }

    const fetchCustomizationManagerList = (query) => {
        return network.api('get', '/company/customization-manager'+query);
    }

    const storeCustomizationManager = (data, query) => {
        return network.api('post', '/company/customization-manager'+query, data);
    }

    const fetchSingleCustomizationManager = (customizationId, query) => {
        return network.api('get', '/company/customization-manager/' + customizationId + query);
    }

    const updateCustomizationManager = (data, customizationId, query) => {
        return network.api('put', '/company/customization-manager/'+ customizationId + query, data);
    }

    const fetchActiveCustomizationManagerTemplate = (query) => {
        return network.api('get', '/company/get-active-customization-template' + query);
    }
    const fetchFieldTypesList = (query) => {
        return network.api('get', '/company/get-field-types'+query);
    }
    const fetchCustomizationFields = (query) => {
        return network.api('get', '/company/get-customization-fields'+query);
    }
    const storeFieldCustomization = (data, query) => {
        return network.api('post', '/company/field-customization'+query, data);
    }

    const fetchActiveCustomizationField = (query) => {
        return network.api('get', '/company/get-active-customization-fields'+query);
    }

    return {
        fetchSidebar,
        fetchCompanyInfo,
        fetchCompanyModules,
        createCompany,
        fetchUpdateCompany,
        fetchCompanyList,
        fetchMenu,
        updateMenu,
        compareWithUpdateMenu,
        getDashboard,
        makeStatistics,
        commaFormat,
        loading,
        fetchAllModules,
        fetchCompanyDetails,
        clearCompanyData,
        storeCustomizationManager,
        fetchCustomizationManagerList,
        fetchSingleCustomizationManager,
        updateCustomizationManager,
        fetchActiveCustomizationManagerTemplate,
        fetchFieldTypesList,
        fetchCustomizationFields,
        storeFieldCustomization,
        fetchActiveCustomizationField
    }
}
